/**
 * Monitoring port. The hooks in this package call into a reporter
 * implementing this interface so they can stay app-agnostic — each
 * host (applicant-web, admin-web) injects its own implementation
 * wired to Sentry / console / whatever.
 *
 * `attrs` is forwarded as-is so the host's reporter can map it into
 * Sentry tags / Crashlytics keys / Amplitude properties without
 * imposing a key vocabulary here.
 */
export interface IMonitoringReporter {
  reportError(err: unknown, context?: Readonly<Record<string, unknown>>): void;
  reportEvent(name: string, attrs?: Readonly<Record<string, unknown>>): void;
}

/**
 * No-op reporter used as the default. Callers that don't pass a
 * reporter get silent telemetry — appropriate for tests and for
 * embeddings that don't care about packet-download metrics yet.
 */
export const noopReporter: IMonitoringReporter = {
  reportError: () => undefined,
  reportEvent: () => undefined,
};
